import React from "react"
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useDialogStyles from "./Dialog.style"

function DialogBox(props) {
    const { open, title, onClose, children, onSave, maxWidth = "sm", fullWidth = false, type = "dialog" } = props;
    const classes = useDialogStyles();
    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
            <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
                <Typography variant="h6" classes={{ root: classes.title }}>{title}</Typography>
                <IconButton classes={{ root: classes.button }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent classes={{ root: classes.dialogContent }}>
                {children}
            </DialogContent>
            <DialogActions>
                {onSave && type === "dialog" && <Button variant="contained" autoFocus onClick={onSave} color="primary">
                    Save
          </Button>}
                {
                    type !== "dialog" && <>
                        <Button onClick={onClose} color="primary">Cancel</Button>
                        <Button variant="contained" autoFocus onClick={onSave} color="primary">Ok</Button>
                    </>
                }
            </DialogActions>
        </Dialog>
    )
}

export default DialogBox;
